import { SET_LOT_LIST_COUNT } from 'ACTIONS';

export const setLotListCount = (count, queryString, location, ppType) => dispatch => dispatch({
    type: SET_LOT_LIST_COUNT,
    count,
    location,
    queryString,
    ppType
});
